import classNames from 'classnames';
import React from 'react';
import s from './styles.module.css.json';
export function Button(_a) {
    var _b;
    var children = _a.children, style = _a.style, className = _a.className, selected = _a.selected, disabled = _a.disabled, onClick = _a.onClick;
    return (React.createElement("button", { type: "button", onClick: onClick, disabled: disabled, className: classNames(s.Button, (_b = {},
            _b[s['Button--selected']] = selected,
            _b[s['Button--disabled']] = disabled,
            _b), className), style: style }, children));
}
//# sourceMappingURL=index.js.map